// extracted by mini-css-extract-plugin
export default {"DeadlineContainer":"Deadline_DeadlineContainer__Z4TKj","DeadlineTitle":"Deadline_DeadlineTitle__8ELLx","DeadlineInput":"Deadline_DeadlineInput__kJyfp"};